import React from 'react'
import PropTypes from 'prop-types'

import StarrySection from './Section'
import Uploader from 'components/EmbedForm/test-drive/Uploader'

// NOTE: string 'test-drive' in hash is used gatsby-browser.js
export const SCROLL_NAME = 'pdf-templates-test-drive'

export default function PDFTemplatesTestDrive ({
  title = 'Turn your PDF into an API-fillable template in seconds.',
  highlight = 'in seconds',
  ...others
}) {
  const decoratedTitle = (
    <>
      {title
        .split(new RegExp(`(${highlight})`))
        .filter(Boolean)
        .map((text, index) =>
          text === highlight ? <span key={index}>{text}</span> : text
        )}
    </>
  )

  return (
    <StarrySection
      scrollName={SCROLL_NAME}
      title={decoratedTitle}
      description="Upload any PDF and watch Anvil Document AI in action. No signup required."
      mode="pdf-templates"
      {...others}
    >
      <Uploader mode="pdf-templates" />
    </StarrySection>
  )
}

PDFTemplatesTestDrive.propTypes = {
  title: PropTypes.string,
  highlight: PropTypes.string,
}
